import { ArrowRight, Building2, LineChart, Users } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle, cn, focusRing } from '@insightai/ui'
import { Link } from 'react-router-dom'

/** M00-06 — three persona cards, matching the FSD's audience segments. */
const PERSONAS = [
  {
    Icon: LineChart,
    audience: 'SMB marketing lead',
    headline: 'You need an answer, not a methodology course',
    body: 'Describe the decision you are facing in plain language. The platform picks the method, shows the cost range, and a Research Lead checks the design before anything is fielded.',
    cta: { label: 'Start a free brief', to: '/auth/signup' },
  },
  {
    Icon: Building2,
    audience: 'Enterprise insights team',
    headline: 'You have briefs, standards and a tracker to protect',
    body: 'Upload existing briefs for parsing, keep tracking wording locked across waves, and hand stakeholders a report where every finding links back to the problem statement.',
    cta: { label: 'See the methodology', to: '/methodology' },
  },
  {
    Icon: Users,
    audience: 'Research agency',
    headline: 'You need throughput without losing rigour',
    body: 'Run desk research, quant fieldwork and qual sessions in one place, with questionnaire auditing and measurement governance applied before launch rather than after.',
    cta: { label: 'Explore capabilities', to: '/solutions' },
  },
]

export function PersonaCards() {
  return (
    <section
      aria-labelledby="persona-heading"
      className="border-y border-border-subtle bg-surface-raised"
    >
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <h2 id="persona-heading" className="text-h1">
          Built for three kinds of team
        </h2>

        <ul className="grid gap-4 pt-8 lg:grid-cols-3">
          {PERSONAS.map(({ Icon, audience, headline, body, cta }) => (
            <li key={audience}>
              <Card className="flex h-full flex-col" surface="flat">
                <CardHeader>
                  <p className="flex items-center gap-2 text-caption uppercase tracking-wide text-text-tertiary">
                    <Icon aria-hidden className="size-3.5" />
                    {audience}
                  </p>
                  <CardTitle className="pt-1 text-h3">{headline}</CardTitle>
                </CardHeader>
                <CardContent className="mt-auto flex flex-col gap-4">
                  <p className="text-body-sm text-text-secondary">{body}</p>
                  <Link
                    to={cta.to}
                    className={cn(
                      'inline-flex w-fit items-center gap-1.5 rounded-md text-body-sm font-medium text-text-link hover:text-brand-primary-hover',
                      focusRing,
                    )}
                  >
                    {cta.label}
                    <ArrowRight aria-hidden className="size-3.5" />
                  </Link>
                </CardContent>
              </Card>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
